exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".media-player{position:relative}.media-player video{display:block;width:100vw;height:100vh}.media-player .ad-container{position:absolute;top:0;left:0}.media-player :focus{outline:0}.media-player ::-moz-focus-inner{border:0}\n", ""]);

// exports
